import React from 'react'

import CellButtonsClients from '../../_atoms/CellButtonsClients/CellButtonsClients'

import styles from './styles.module.scss'

interface IProps {
    editModal: () => void
    deleteModal: () => void
}

const CellActionsClients = ({ editModal, deleteModal }: IProps) => {
    return (
        <div className={styles.wrap}>
            <CellButtonsClients editModal={editModal} deleteModal={deleteModal} />
        </div>
    )
}

export default CellActionsClients
